import { Injectable } from '@angular/core';

import { Resolve } from '@angular/router';
import {Observable} from 'rxjs';
import {ApiService, Vps} from '../api/api.service';

@Injectable()
export class VpsResolver implements Resolve<Observable<Vps[]>> {

  constructor(private api: ApiService) {}

  resolve() {
    return this.api.getVpsInfo();
  }
}
